export const BULK_MAINTENANCE_ERROR_MESSAGES = {
  COMMON: {
    DUPLICATE_RECORD: 'Duplicate Record',
    REQUIRED_FIELD: (label: string) => `${label} is required`,
    SHOULD_BE_NUMBER: (label: string) => `${label} should be a number`,
    SHOULD_BE_INTEGER: (label: string) => `${label} should be an integer`,
    CONVERSION_ERROR: (label: string) => `${label} conversion error`,
    UNEXPECTED_ERROR: 'Unexpected Error Occurred',
    FILE_PROCESSING_ERROR_PREFIX: 'Error processing file: ',
    ZERO_RECORDS_FOUND: 'From excel file found 0 records',
    VALIDATION_FAILED_PREFIX: 'Primary Upload data Validation Failed!',
  },

  PRIMARY_UPLOAD: {
    UPDATE_TYPE_EMPTY: 'Update Type is empty',
    UPDATE_TYPE_INVALID: 'Update Type is not valid',
    APP_ID_EMPTY: 'App Id is empty',
    LOB_ID_EMPTY: 'LOB Id is empty',
    SUB_LOB_ID_EMPTY: 'SubLOB Id is empty',
    GROUP_MODEL_EMPTY: 'Group Model is empty',
    CAPABILITY_L0_ID_EMPTY: 'Capability L0 Id is empty',
    CAPABILITY_L1_ID_EMPTY: 'Capability L1 Id is empty',
    PRIMARY_STATUS_EMPTY: 'Primary status is empty',
    PRIMARY_STATUS_INVALID: 'Inavlid Primary status value',
    INVALID_CAPABILITY_HIERARCHY:
      'Invalid capability Hierarchy. Capability L2 canot be empty for the given Capability L3',
  },

  APP_DEMOGRAPHIC: {
    UPDATE_TYPE_EMPTY: 'Update Type is Required',
    UPDATE_TYPE_INVALID: 'Update Type is not valid',
    GLOBAL_APP_ID_MISSING: 'GLOBAL APP ID value is missing',
    LOB_ID_MISSING: 'LOB ID value is missing',
    SUB_LOB_ID_MISSING: 'Sub LOB ID value is missing',
    CATEGORY_ID_MISSING: 'Category_ID value is missing',
    APPLICATION_TYPE_ID_MISSING: 'Application_Type_Id value is missing',
    APPLICATION_HOSTING_ID_MISSING: 'Application_Hosting_ID value is missing',
  },

  MODEL_EDIT: {
    UPDATE_TYPE_EMPTY: 'Update Type is empty',
    UPDATE_TYPE_INVALID: 'Update Type is not valid',
    GROUP_MODEL_EMPTY: 'Group Model is empty',
    CAPABILITY_L0_ID_EMPTY: 'Capability L0 Id is empty',
    CAPABILITY_L0_EMPTY: 'Capability L0 is empty',
    CAPABILITY_L0_DESC_EMPTY: 'Capability L0 Desc is empty',
    CAPABILITY_L1_ID_EMPTY: 'Capability L1 Id is empty',
    CAPABILITY_L1_EMPTY: 'Capability L1 is empty',
    CAPABILITY_L1_DESC_EMPTY: 'Capability L1 Desc is empty',
    CAPABILITY_L2_ID_EMPTY: 'Capability L2 Id is empty',
    CAPABILITY_L3_ID_EMPTY: 'Capability L3 Id is empty',
  },

  BUSINESS_SUPPORT: {
    UPDATE_TYPE_EMPTY: 'Update Type is empty',
    UPDATE_TYPE_INVALID: 'Update Type is not valid',
    GLOBAL_APP_ID_MISSING: 'GLOBAL APP ID value is missing',
    LOB_ID_MISSING: 'LOB ID value is missing',
    SUB_LOB_ID_MISSING: 'Sub LOB ID value is missing',
    INVALID_PADU_COLUMN_VALUE: (column: string) => `Invalid ${column} value`,
    INVALID_PADU_MESSAGE: (key: string) => `Invalid ${key} & Please check instructions`,
    INVALID_REQUIRED_VALUE: (column: string) => `${column} value is missing`,
  },

  INITIATIVE: {
    UPDATE_TYPE_REQUIRED: 'Update Type is Required',
    UPDATE_TYPE_INVALID: 'Invalid Update Type',
    APPLICATION_ID_INVALID: 'Invalid Application ID',
  },

  FORECAST_BULK: {
    GENERIC_ERROR: 'Something went wrong, Please try again later.',
    FILE_FORMAT_UNSUPPORTED: 'File format is not supported, Please try with excel files only.',
    SUBMIT_SUCCESS:
      'Thank you for submitting the request. You will be notified via email on status',
    UPDATE_TYPE_EMPTY: 'Update Type is empty',
    UPDATE_TYPE_INVALID: 'Update Type should be only A or U',
    ASK_GLOBAL_ID_REQUIRED: 'ASK_Global_Id is required',
    SERVICE_REQUIRED: 'service is required',
    YEAR_REQUIRED: 'year is required',
    YEAR_INVALID_PREFIX: 'year should be one of ',
    NOT_EDITABLE: 'This forecast details is not editable',
    DUPLICATE_RECORD: 'Duplicate Record',
    MONTH_INTEGER_SUFFIX: ' must be an integer',
    VALIDATION_FAILED_PREFIX: 'Error while validating the records',
    UNEXPECTED_ERROR: 'Unexpected Error Occurred',
    FILE_PROCESSING_ERROR_PREFIX: 'Error processing file: ',
    FILE_READING_ERROR: 'Error reading file',
  },

  CAPITAL_DEMAND_BULK: {
    GENERIC_ERROR: 'Something went wrong, Please try again later.',
    FILE_FORMAT_UNSUPPORTED: 'File format is not supported, Please try with excel files only.',
    SUBMIT_SUCCESS:
      'Thank you for submitting the request. You will be notified via email on status',

    UPDATE_TYPE_REQUIRED: 'Update type is required',
    UPDATE_TYPE_INVALID: 'Invalid Update type it should be A or U or D',
    UPDATE_TYPE_INVALID_WITH_ROLES:
      'Invalid Update type it should be A or U or D or Roles_Update',
    FUNDING_SEGMENT_ID_REQUIRED: 'Funding SegmentID is required',
    UCMG_ID_REQUIRED: 'UCMG ID is required',
    UCMG_REQUIRED: 'UCMG is required',
    UCMG_OWNER_REQUIRED: 'UCMG Owner is required',
    PORTFOLIO_MANAGER_REQUIRED: 'Portfolio Manager is required',
    FISCAL_YEAR_REQUIRED: 'Fiscal Year is required',
    L1_MSID_REQUIRED: 'L1 MSID is required',
    L2_MSID_REQUIRED: 'L2 MSID is required',
    L3_MSID_REQUIRED: 'L3 MSID is required',
    OT_LABOR_REQUIRED: 'OT Labor is required',
    INVESTMENT_STATUS_REQUIRED: 'Investment Status is required',
    INVESTMENT_STATUS_INVALID:
      'Investment Status should be Active or Inactive',
    VALIDATION_FAILED_PREFIX: 'Error validating records:',
    OPTUM_TECH_LABOR_REQUIRED: 'Optum Tech Labor is required',
    ADVISORY_SERVICES_REQUIRED: 'Advisory Services is required',
    BUSINESS_LABOR_REQUIRED: 'Business Labor is required',
    HARDWARE_SOFTWARE_REQUIRED: 'Hardware/Software is required',
    PROFESSIONAL_FEES_REQUIRED: 'Professional Fees is required',
    OTHER_CHARGEBACKS_REQUIRED: 'Other Chargebacks is required',
  },
};
